import _ from 'lodash';

if (document.querySelector('body').classList.contains('js-layout-investor-dashboard')) {



  (function () {

    /**
         * Main Dashboard Navigation
         */
    const SITE_HEADER = document.querySelector('header.main-header');
    const DASHBOARD_NAV = document.querySelector('.rw-dash-nav');
    const MAIN_CONTENT_INNER = document.querySelector('.main-content__inner');
    const GLOBAL_ALERT = document.querySelector('.rw-global-alert');

    if (!DASHBOARD_NAV) return false;

    let debouncedAdjustLayoutHeights = _.debounce(function () {
      console.log('debouncedAdjustLayoutHeights');
      adjustLayoutHeights();
    }, 100);

    let adjustLayoutHeights = () => {
      let dashboardNavHeight = (window.innerHeight - SITE_HEADER.clientHeight) - 1; // the decimal point pixel heights make this slightly off.. need to account for that
            
      if(document.querySelector('body').classList.contains('layout--has-alert')) {
        dashboardNavHeight = (dashboardNavHeight - GLOBAL_ALERT.clientHeight); // the decimal point pixel heights make this slightly off.. need to account for that

      }

      // DASHBOARD_NAV.style.height = `${dashboardNavHeight}px`;
      MAIN_CONTENT_INNER.style.height = `${dashboardNavHeight}px`;
    };

    // if (window.outerWidth >= 1024) {
    //   adjustLayoutHeights();
    // }

    // window.onresize = () => debouncedAdjustLayoutHeights();

    window.scrollDashboardToTop = () => {
      console.log('scrollDashboardToTop');
      MAIN_CONTENT_INNER.scrollTo(0, top);
    }


  }());

  (function () {

    /**
         * Filter Bar Navigation
         */
    const FILTER_BAR_TOGGLE = document.querySelector('.js-filter-bar-toggle');
    const FILTER_BAR_TOGGLE_TEXT = document.querySelector('.js-filter-bar-toggle .the-text');

    if (FILTER_BAR_TOGGLE && window.outerWidth < 992) {
      FILTER_BAR_TOGGLE.addEventListener('click', function (e) {
        if (FILTER_BAR_TOGGLE_TEXT.innerHTML == 'Show Filter') {
          FILTER_BAR_TOGGLE_TEXT.innerHTML = 'Hide Filter';
          FILTER_BAR_TOGGLE.classList.add('btn-mini-cta--outline');
        } else {
          FILTER_BAR_TOGGLE_TEXT.innerHTML = 'Show Filter';
          FILTER_BAR_TOGGLE.classList.remove('btn-mini-cta--outline');
        }
      });
    }


  }());


  (function () {

    /**
     * Filter Bar Input Events
     */
    const FILTER_BAR_INPUTS = document.querySelectorAll('.filter-bar input');

    var closest = function (el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    for (var i = 0; i < FILTER_BAR_INPUTS.length; i++) {
      FILTER_BAR_INPUTS[i].addEventListener('change', function (e) {
        var inputWrapper = closest(this, function (el) {
          return el.classList.contains('rwfc');
        });
        console.log(inputWrapper);
        inputWrapper.classList.add('rwfc--active');
      });
    }


  }());


  (function(){

    const NAV_TOGGLE = document.getElementById('rw-dash-nav-toggle');
    const PRIMARY_NAV_TOGGLE = document.querySelector('.nav-toggle');
    const MAIN_NAV_DRAWER = document.querySelector('.main-header__nav-drawer');
    const RESOURCES_BAR_NAV_DRAWER = document.querySelector('.main-header__resources-bar__nav-drawer');

    if(!NAV_TOGGLE) return false;

    const NAV_DRAWER = document.querySelector('.rw-dash-nav');
        
    NAV_TOGGLE.addEventListener('click', (evt) => {

      console.log('clicked');
      evt.preventDefault();
      NAV_DRAWER.classList.toggle('rw-dash-nav--nav-active');
      NAV_TOGGLE.classList.toggle('rw-dash-nav__toggle--active');
      PRIMARY_NAV_TOGGLE.classList.remove('nav-toggle--active');
      MAIN_NAV_DRAWER.classList.remove('shown');
      RESOURCES_BAR_NAV_DRAWER.classList.remove('shown');
    });

  }());

}